import React from "react";
import { useCurrentUser } from "APP_ROOT/hooks";
import { Modal } from "MODULES/shared/components";
import { Close, Header } from "MODULES/shared/components/Modal";
import { get } from "lodash";
import { CODE, EMAIL, NAME, REPAIRS_FROM_EMAIL } from "APP_ROOT/constants";
import { SERIAL_NUMBER } from "MODULES/inventories/constants";
import { CONTACT } from "MODULES/companies/constants";
import Form from "./Form";

export function RequestScrapAtShop({ close, editing, inventory }) {
  const currentUser = useCurrentUser();

  const code = inventory.getIn(["most_recent_repair_order", CODE]);

  return (
    <Modal open={editing} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Request Scrap Certificate</h4>
      </Header>
      <Form
        close={close}
        initialValues={{
          from: currentUser.email,
          to: inventory.getIn(["most_recent_repair_order", CONTACT, EMAIL]),
          cc: get(currentUser.tenant, REPAIRS_FROM_EMAIL),
          subject: `${code} Request for Scrap`,
          body: `Hi ${inventory.getIn([
            "most_recent_repair_order",
            CONTACT,
            NAME
          ])},\n\nPlease scrap PN ${inventory.getIn([
            "part",
            "part_number"
          ])} SN ${inventory.get(
            SERIAL_NUMBER
          )} from ${code} and send back Scrap Certificate at your earliest convenience.\n\nThank you,\n\n${currentUser.full_name}`
        }}
        inventory={inventory}
        enableReinitialize
      />
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/RequestScrapAtShop/RequestScrapAtShop.jsx